import { isHtmlWithText } from './isHtmlWithText';

export const getTextWithTag = (text = '', tag?: string): string => {
    if (!text || !tag) {
        return text;
    }
    return `<${tag}>${isHtmlWithText(text)}</${tag}>`;
};
